import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ContextDossier } from '@kv-common-components/kv-common-components';
import {
    ArmService,
    AuthenticationService,
    CodeMobileService,
    DossierMedicalService,
    EspaceClientService,
    EspaceDocumentaireService,
    FoldersService,
    User,
    ConsentementsService,
} from '@kv-common-components/kx-services';
import { StyleService } from '@shared/services/style.service';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-document-selection-type-component',
    templateUrl: './document-selection-type.component.html',
    styleUrls: ['./document-selection-type.component.scss'],
})
export class DocumentSelectionTypeComponent implements OnDestroy {
    @ViewChild('fileInput') fileInput: ElementRef<HTMLElement>;
    openCamera = false;
    getSms = false;
    telephone: string;
    modalContent: string;
    user: User;
    codeMobile: string;
    uploadedFiles: any[];
    document: any;
    folder: any;
    espaceClient: any;
    acceptedFileExtensions: string[] = ['jpg', 'jpeg', 'png', 'pdf'];
    maxSize: number = 10 * 1024 * 1024; // 10MB
    showErrorModal = false;
    showUploadErrorModal = false;
    confirmFilesDeleteModal = false;
    showSubmitButton = false;
    showSmallLoader = false;
    smallLoaderContent: string;
    iconLoading = false;
    uploadSuccess = false;
    maxNbOfUploads = 15;
    errorModalContent: string;
    showAuthorisationPhototheque = false;
    showAuthorisationCamera = false;
    giveAuthorisationPhototheque = false;
    giveAuthorisationCamera = false;
    documentStatus = {
        created: 1,
        analyzing: 2,
        ok: 3,
        ko: 4,
        nc: 5,
    };
    secToWaitBeforeDocCheck = 5;
    maxAttemps = 12;
    showJouveWarningModal = false;
    errorKey = 'NC';
    showMaxAttempsModal = false;

    constructor(
        private espaceClientService: EspaceClientService,
        private espaceDocumentaireService: EspaceDocumentaireService,
        private authenticationService: AuthenticationService,
        private codeMobileService: CodeMobileService,
        private logger: NGXLogger,
        private folderService: FoldersService,
        private armService: ArmService,
        private dossierMedicalService: DossierMedicalService,
        private router: Router,
        private styleService: StyleService,
        private consentementsService: ConsentementsService
    ) {
        this.styleService.updatePageStyle('add', 'colored');
        this.styleService.updatePageStyle(
            'add',
            'document-selection-type-page'
        );
        this.user = this.authenticationService.currentUserValue;
        this.espaceClientService
            .getEspaceClient(this.user.idPersonne)
            .subscribe((data) => {
                this.checkPropositionPrincipale(data);
                this.espaceClient = data;
                const start = String(data.personne.telephone).substring(0, 2);
                const end = String(data.personne.telephone).substring(
                    data.personne.telephone.length - 2
                );
                const mask = data.personne.telephone
                    .substring(2, data.personne.telephone.length - 2)
                    .split('')
                    .join(' ')
                    .replace(/\d/g, '*');
                this.telephone = start + ' ' + mask + ' ' + end;

                if (
                    history.state &&
                    history.state.data &&
                    history.state.data.folder
                ) {
                    this.folder = history.state.data.folder;
                    this.createDocument();
                } else {
                    const personId = data.personne.idPersonne;
                    const project = data.listeProjetsCredits.find(
                        (projet) =>
                            projet.idProjetCredit === this.user.idDossier
                    );
                    const idSousDossier = project.listeEmprunteurs.find(
                        (emprunteur) => emprunteur.idPersonne === personId
                    ).idSousDossier;
                    this.folderService
                        .getOrCreateFolder(
                            idSousDossier,
                            personId,
                            'Assurance_Emprunteur'
                        )
                        .subscribe((folder) => {
                            this.folder = folder;
                            this.createDocument();
                        });
                }
            });
    }

    ngOnDestroy(): void {
        this.styleService.updatePageStyle('remove', 'colored');
        this.styleService.updatePageStyle(
            'remove',
            'document-selection-type-page'
        );
    }

    showCodeModal() {
        this.getnewCode();
        this.getSms = true;
        this.openCamera = false;
    }
    saveAuthorisationPhotothequeOrCamera(codeConsentement: string) {
        this.consentementsService
            .postSaveConsentementEADE(
                codeConsentement,
                this.espaceClient.personne.idAia,
                this.user.idDossier
            )
            .subscribe((data: any) => {
                if (codeConsentement === 'CONSENTEMENTS_PHOTOTEQUE') {
                    this.showAuthorisationPhototheque = false;
                    this.giveAuthorisationPhototheque = true;
                } else if (
                    codeConsentement === 'CONSENTEMENTS_APPAREIL_PHOTO'
                ) {
                    this.showAuthorisationCamera = false;
                    this.giveAuthorisationCamera = true;
                }
                this.fileInput.nativeElement.click();
                this.logger.debug(
                    'consentementsService.postAuthorisationPhotothequeOrCamera response : ',
                    { data }
                );
            });
    }
    openCameraOrPhototheque(cameraOrPhototheque: string) {
        if (cameraOrPhototheque === 'camera') {
            if (this.giveAuthorisationCamera) {
                this.fileInput.nativeElement.click();
                this.logger.debug(
                    'acces to camera is already given, open pop-in upload'
                );
            } else {
                this.showAuthorisationCamera = true;
            }
        } else if (cameraOrPhototheque === 'phototheque') {
            if (this.giveAuthorisationPhototheque) {
                this.fileInput.nativeElement.click();
                this.logger.debug(
                    'acces to phototheque is already given, open pop-in upload'
                );
            } else {
                this.showAuthorisationPhototheque = true;
            }
        }
    }
    getnewCode() {
        this.iconLoading = true;
        const selectedDocumentType = localStorage.getItem(
            'selectedDocumentType'
        );
        this.codeMobileService
            .postCodeMobile(
                this.user.idPersonne,
                this.user.idDossier,
                selectedDocumentType
            )
            .subscribe((data: any) => {
                this.codeMobile = data.oneTimePassword.split('');
                this.iconLoading = false;
                this.logger.debug(
                    'codeMobileService.postValidation response : ',
                    { data }
                );
            });
    }

    // checks files validity and uploads them in preparation of jouve quality check
    handleFilesUpload(files: FileList): void {
        if (files.length > 0) {
            const filesArray = Array.from(files);
            if (this.filesAreValid(filesArray)) {
                filesArray.forEach((file, i) => {
                    this.uploadFile(file, i);
                });
            } else {
                this.showErrorModal = true;
            }
        }
    }

    // uploads a single file in preparation of jouve quality check
    uploadFile(file: File, index: number): void {
        this.smallLoaderContent = 'global.loading.text';
        this.showSmallLoader = true;
        const extension = file.name.split('.').pop();
        const fileName = file.name.split('.').slice(0, -1).join('.');
        const newFileName = `${this.replaceSpecialCharacters(
            fileName,
            '_'
        )}.${extension}`;
        Object.defineProperty(file, 'name', {
            writable: true,
            value: newFileName,
        });
        const position = this.uploadedFiles.length + index + 1;
        this.folderService
            .uploadFile(this.document.id, file, position)
            .subscribe(
                (response) => {
                    const uploadedFile = {
                        ...response,
                        name: fileName + '.' + extension,
                    };
                    this.handleUploadSuccess(uploadedFile);
                },
                () => {
                    this.showSmallLoader = false;
                    this.showUploadErrorModal = true;
                }
            );
    }

    toggleConfirmFilesDeleteModal(): void {
        this.confirmFilesDeleteModal = !this.confirmFilesDeleteModal;
    }

    // deletes jouve document and its uploads and creates and a brand new jouve document with no uploads
    deleteFiles(): void {
        this.confirmFilesDeleteModal = false;
        this.smallLoaderContent = 'global.loading';
        this.showSmallLoader = true;
        this.folderService.deleteDocument(this.document.id).subscribe(
            () => {
                // After deleting the document and it's files, we create a new one with an empty uploads list
                this.folderService
                    .createDocument(this.folder.id, this.document.type)
                    .subscribe(
                        (createdDoc) => {
                            this.document = createdDoc;
                            this.uploadedFiles = [];
                            this.showSmallLoader = false;
                        },
                        () => {
                            this.showSmallLoader = false;
                        }
                    );
            },
            () => {
                this.showSmallLoader = false;
            }
        );
    }

    extensionsAreValid(files: File[]): boolean {
        let extensionsValidity = false;
        for (const file of files) {
            const extension = file.name.split('.').pop().toLocaleLowerCase();
            if (this.acceptedFileExtensions.includes(extension)) {
                extensionsValidity = true;
            } else {
                extensionsValidity = false;
                // all files must be valid (if one isn't valid then all the other files become invalid two)
                break;
            }
        }
        if (!extensionsValidity) {
            this.errorModalContent =
                'documentselectiontype.modal.error.message';
        }
        return extensionsValidity;
    }

    sizesAreValid(files: File[]): boolean {
        for (const file of files) {
            if (file.size > this.maxSize) {
                this.errorModalContent =
                    'documentselectiontype.modal.error.message';
                return false;
            }
        }
        return true;
    }

    uploadedFilesNbIsValid(files: File[]): boolean {
        const filesNbValidity = files.length + this.uploadedFiles.length <= 15;
        if (!filesNbValidity) {
            this.errorModalContent =
                'documentselectiontype.modal.error.maxfiles.message';
        }
        return filesNbValidity;
    }

    // Asks Jouve to start analyzing submitted uploads
    handleSumbit(): void {
        this.smallLoaderContent = 'global.loading';
        this.showSmallLoader = true;
        this.folderService.analyzeDocument(this.document.id).subscribe(
            () => {
                this.checkDocumentQuality();
            },
            (error) => {
                const errorMessage =
                    'Could not ask Jouve to start analyzing document';
                this.handleDocumentError(errorMessage, error);
            }
        );
    }

    checkDocumentQuality(): void {
        let document = null;
        let status = this.documentStatus.analyzing;
        let attempt = 0;
        // We request the server every 5 seconds (secToWaitBeforeDocCheck) to check the analyzing status
        const intervalId = setInterval(() => {
            if (
                status === this.documentStatus.analyzing &&
                attempt < this.maxAttemps
            ) {
                this.folderService.getDocument(this.document.id).subscribe(
                    (doc) => {
                        status = doc.status;
                        document = doc;
                    },
                    (error) => {
                        const errorMessage =
                            'A request for checking document quality has failed';
                        this.handleDocumentError(errorMessage, error);
                    }
                );
                attempt += 1;
            } else {
                // We no longer request the server for document quality check (different cases are possible)
                if (attempt === this.maxAttemps) {
                    this.showSmallLoader = false;
                    this.logger.debug(
                        'Max Attemps reached while checking document quality'
                    );
                    this.showMaxAttempsModal = true;
                } else {
                    if (status === this.documentStatus.ok) {
                        this.handleSufficientQualityDoc(status);
                    } else {
                        this.showSmallLoader = false;
                        this.handleInsufficientQualityDoc(document, status);
                    }
                }
                // stops the document quality process
                clearInterval(intervalId);
            }
        }, this.secToWaitBeforeDocCheck * 1000);
    }

    // gets pdf file from jouve and uploads it to the documentary space
    handleSufficientQualityDoc(status?: number): void {
        if (status) {
            this.logger.debug(
                'document passes Jouve quality check - status: ',
                status
            );
        } else {
            this.logger.debug(
                `document does not pass jouve quality check but client wants to upload the files anyway`
            );
        }
        this.folderService.getDocumentPdf(this.document.id).subscribe(
            (response) => {
                const type = response.headers.get('Content-Type');
                const blob = new Blob([response.body], { type });
                const metaData = {
                    nom: `${this.document.type}.pdf`,
                    typologie: this.document.type,
                };
                this.uploadDocToDocumentarySpace(metaData, blob);
            },
            (error) => {
                const errorMessage = 'Could not get document PDF';
                this.handleDocumentError(errorMessage, error);
            }
        );
    }

    // Shows a warning modal with the correct jouve error
    handleInsufficientQualityDoc(doc: any, status: number): void {
        this.logger.debug(
            'document does not pass Jouve quality check - status: ',
            status
        );
        const controlErrors = this.getControlErrors(doc);
        if (controlErrors && controlErrors.length > 0) {
            // get most important error
            this.errorKey = controlErrors[0].name;
        }
        this.showJouveWarningModal = true;
    }

    uploadDocToDocumentarySpace(metaData: any, pdf: any): void {
        const idPersonne =
            this.authenticationService.currentUserValue.idPersonne;
        const idProposition =
            this.authenticationService.currentUserValue.idPropositionPrincipale;
        this.espaceDocumentaireService
            .uploadDocument(
                JSON.stringify(metaData),
                pdf,
                idPersonne,
                idProposition
            )
            .subscribe(
                (resp) => {
                    if (resp.idGed) {
                        this.logger.debug(
                            'Document was successfully uploaded to GED'
                        );
                        this.notifyArmOfUpload();
                    }
                },
                (error) => {
                    const errorMessage =
                        'Could not upload document to documentary space';
                    this.handleDocumentError(errorMessage, error);
                }
            );
    }

    // client decides to send document any way
    handleSendDocument(): void {
        this.showJouveWarningModal = false;
        this.showSmallLoader = true;
        this.handleSufficientQualityDoc();
    }

    removeTarget(target) {
        target.value = '';
    }

    // client decides to rescan
    handleRescanDocument(): void {
        this.showJouveWarningModal = false;
        this.deleteFiles();
    }

    // notifies ARM api of files upload, deletes jouve document & goes back to document list page
    notifyArmOfUpload(): void {
        const idAia = this.espaceClient.personne.idAia;
        const idDossier =
            this.authenticationService.currentUserValue.idDossier.toString();
        this.dossierMedicalService
            .getIdDossierMedical(idAia, idDossier)
            .subscribe(
                (resp) => {
                    this.armService
                        .getTypesExamens()
                        .subscribe((typesExamens) => {
                            const idDossierMedical = resp.idDossierMedical;
                            const examenARM = typesExamens.find(
                                (exam) =>
                                    exam.typeEmprunteur === this.document.type
                            );
                            if (examenARM) {
                                const documentIdApi = examenARM.idApi;
                                // notify ARM API that file was uploaded
                                this.armService
                                    .notifyUpload(
                                        idDossierMedical,
                                        documentIdApi
                                    )
                                    .subscribe(
                                        () => {
                                            this.logger.debug(
                                                'Notified ARM API of file upload'
                                            );
                                            this.deleteJouveDocument();
                                        },
                                        (error) => {
                                            const errorMessage =
                                                'Could not notify ARM of document upload';
                                            this.handleDocumentError(
                                                errorMessage,
                                                error
                                            );
                                        }
                                    );
                            } else {
                                this.deleteJouveDocument();
                            }
                        });
                },
                () => {
                    // if no dossier medical was found continue & delete jouve document
                    this.deleteJouveDocument();
                }
            );
    }

    private deleteJouveDocument(): void {
        // delete jouve document
        this.folderService.deleteDocument(this.document.id).subscribe(() => {
            this.smallLoaderContent = 'global.loading.success.document';
            this.uploadSuccess = true;
            setTimeout(() => {
                this.showSmallLoader = false;
                this.uploadSuccess = false;
                this.navigateToDocumentList();
            }, 600);
        });
    }

    private getControlErrors(doc: any): any[] {
        /* eslint-disable @typescript-eslint/naming-convention */
        const controlRank = {
            CTRL_PAGE_QUAL_IMAG_RESO: 10,
            CTRL_PAGE_QUAL_IMAG_BLUR: 20,
            CTRL_PAGE_QUAL_IMAG_BRIG: 21,
            CTRL_PAGE_QUAL_IMAG_REFL: 23,
            CTRL_DOCU_CHCK_PAGE_NMBR: 30,
            CTRL_DOCU_RECO_DOCU_TYPE: 40,
            CTRL_PAGE_PRES_BARR_CODE: 50,
            CTRL_PAGE_PRES_SIGN_DATE: 60,
            CTRL_PAGE_PRES_INSU_SIGN: 70,
            CTRL_PAGE_PRES_DOCT_SIGN: 80,
        };
        /* eslint-enable @typescript-eslint/naming-convention */

        let controlErrors = [...doc.controlErrors];
        doc.uploads.forEach((upload) => {
            controlErrors = controlErrors.concat([...upload.controlErrors]);
        });
        controlErrors.forEach((error) => {
            if (error) {
                error.rank = controlRank[error.control] || 1000;
            }
        });
        controlErrors.sort((a, b) => a.rank - b.rank);

        return controlErrors;
    }

    private createDocument(): void {
        const selectedDocumentType = localStorage.getItem(
            'selectedDocumentType'
        );
        const selectedDocument = this.folder.documents.find(
            (doc) => doc.type === selectedDocumentType
        );
        if (selectedDocument) {
            this.document = selectedDocument;
            this.uploadedFiles = this.document.uploads;
        } else {
            // if document is not in jouve folder we create it
            this.folderService
                .createDocument(this.folder.id, selectedDocumentType)
                .subscribe((resp) => {
                    this.document = resp;
                    this.uploadedFiles = this.document.uploads;
                });
        }
    }

    // adds uploaded file to the uploadedFiles list and shows the right loading messsages
    private handleUploadSuccess(uploadedFile: any): void {
        this.uploadSuccess = true;
        this.smallLoaderContent = 'global.loading.success.document';
        this.uploadedFiles.push(uploadedFile);
        setTimeout(() => {
            this.showSmallLoader = false;
            this.uploadSuccess = false;
        }, 600);
    }

    private navigateToDocumentList(): void {
        this.router.navigateByUrl(
            '/souscription/document-medicale/document-list'
        );
    }

    private filesAreValid(files: File[]): boolean {
        return (
            this.uploadedFilesNbIsValid(files) &&
            this.extensionsAreValid(files) &&
            this.sizesAreValid(files)
        );
    }

    private handleDocumentError(errorMessage: string, error: any): void {
        this.showSmallLoader = false;
        this.logger.error(errorMessage, { error });
    }

    private replaceSpecialCharacters(
        myString: string,
        replaceChar: string
    ): string {
        const regex = /([.*+?^=!:${}()|\[\]\/\\])/gi;
        return myString.replace(regex, replaceChar);
    }

    private checkPropositionPrincipale(espaceClient: any) {
        const user = this.authenticationService.currentUserValue;
        if (!user.idPropositionPrincipale) {
            const idPersonne = user.idPersonne.toString();
            const idDossier = user.idDossier.toString();
            const contextDossier =
                ContextDossier.initContextDossierFromEspaceClient(
                    idPersonne,
                    idDossier,
                    espaceClient
                );
            user.idPropositionPrincipale =
                contextDossier.emprunteur.assurance.idPropositionPrincipale;
            this.authenticationService.updateCurrentUser(user);
            this.user = user;
        }
    }
}
